const tripStatus = require("./tripStatus");
const activeTripStatus = [
  tripStatus.pending,
  tripStatus.scheduled,
  tripStatus.searching,
  tripStatus.dispatched,
  tripStatus.onTheWay,
  tripStatus.arrived,
  tripStatus.clientNoShow,
  tripStatus.clientInTaxi,
  tripStatus.canceling,
  tripStatus.integrationError,
];
module.exports = activeTripStatus;
